import { useMutation } from "react-query";
import { usePostApiData } from "shared/datalayer";
import client from "shared/datasource/apiClient";
import PublicApi from "shared/enums/PublicApi";

export function useLogin({ onLoginSuccess, onLoginError }: { onLoginSuccess: Function; onLoginError?: Function }) {
  return useMutation(login, {
    onSuccess: data => {
      onLoginSuccess(data);
    },
    onError: err => {
      onLoginError?.(err);
    }
  });
}

async function login(body: LoginRequest) {
  const loginBody = new URLSearchParams();
  loginBody.append("username", body.username);
  loginBody.append("password", body.password);
  if (body.registrationId) {
    loginBody.append("regId", body.registrationId);
  }

  const response = await client(PublicApi.LOGIN, {
    body: loginBody,
    trimAndRemoveNull: false,
    parseDataInResponse: false,
    customHeaders: {
      "content-type": "application/x-www-form-urlencoded"
    },
    ignoreLogoutOnAccessDenied: true
  });
  return { ...response.data, accessToken: response.headers["x-auth-token"] };
}

export function useImplicitLogin() {
  return useMutation(handleTokenLogin);
}

async function handleTokenLogin(username: string) {
  const loginBody = new URLSearchParams();
  loginBody.append("username", username);

  const response = await client(PublicApi.LOGIN, {
    body: loginBody,
    trimAndRemoveNull: false,
    parseDataInResponse: false,
    noAuthHeader: true,
    customHeaders: {
      "content-type": "application/x-www-form-urlencoded"
    },
    ignoreLogoutOnAccessDenied: true
  });
  return { ...response.data, accessToken: response.headers["x-auth-token"] };
}

export function useLogout() {
  return usePostApiData(PublicApi.LOGOUT);
}
